import { create } from 'zustand';

interface CloseSecurityDrawerState {
    isDrawerClosed: boolean;
    setIsDrawerClosed: (open: boolean) => void;
}

// Create the Zustand store with types
const CloseSecurityDrawerStore = create<CloseSecurityDrawerState>((set) => ({
    isDrawerClosed: false,
    setIsDrawerClosed: (open: boolean) => set({ isDrawerClosed: open }),
}));

export default CloseSecurityDrawerStore;
